export const PendingIcon = () => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_14616_584)">
      <path
        d="M56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56C43.464 56 56 43.464 56 28Z"
        fill="#FFF8EC"
      />
      <path
        d="M35.1429 16.3889H20.8571C19.2792 16.3889 18 17.6326 18 19.1667V37.2222C18 38.7564 19.2792 40 20.8571 40H35.1429C36.7208 40 38 38.7564 38 37.2222V19.1667C38 17.6326 36.7208 16.3889 35.1429 16.3889Z"
        stroke="#D97706"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.7144 16.3889C23.7144 16.0205 23.8649 15.6673 24.1328 15.4068C24.4007 15.1463 24.764 15 25.1429 15H30.8572C31.2361 15 31.5995 15.1463 31.8674 15.4068C32.1353 15.6673 32.2858 16.0205 32.2858 16.3889V17.7778H23.7144V16.3889Z"
        stroke="#D97706"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23 25.4166L25.1429 27.4999L29.4286 23.3333"
        stroke="#D97706"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.2856 25.4167H35.1428"
        stroke="#D97706"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.0714 33.4028C24.8604 33.4028 25.5 32.781 25.5 32.0139C25.5 31.2468 24.8604 30.625 24.0714 30.625C23.2824 30.625 22.6428 31.2468 22.6428 32.0139C22.6428 32.781 23.2824 33.4028 24.0714 33.4028Z"
        fill="#D97706"
      />
      <path
        d="M28 32.0139H35.1429"
        stroke="#D97706"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_14616_584">
        <rect width="56" height="56" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
